<template>
    <div>
        <div style="display: flex;justify-content: center;">

            <div style="width: 1200px;">
                <Bread :breads="breads" defaultType="2"></Bread>
                <div style="display:flex; justify-content: space-between;">
                    <img src="/static/img/zhuhai/实验室与平台基地.svg" alt="">
                    <el-input class="serach-input"
                              v-model="inputtext"
                              placeholder="请输入想浏览的实验室/平台"
                              clearable
                              style="width:320px;height:40px;border: 2px solid #1EB38A;">
                        <template #append>
                            <el-button :icon="Search"
                                       @click="getPlatformList"
                                       style="background-color: #1EB38A;color: white;border-radius: 0px;height: 100%;width:40px;"/>
                        </template>
                    </el-input>
                </div>

                <div class="platform-content-box" >
                    <el-row>
                        <el-col :span="5">
                            <div class="platform-type"
                                 :class="{active:platformTypeActiveId===item.typeCode}"
                                 v-for="(item,index) in platformTypeList"
                                 :key="index"
                                @click="platformTypeLick(item)"
                            >{{ item.typeName }}</div>



                        </el-col>
                        <el-col :span="19" style="padding-left: 20px;" >
                            <div>
                                <p class="platform-count">共<b style="color: #1EB38A;"> {{ platformListResult.total }} </b>条记录</p>


                                <div style="" v-loading="loading">
                                    <el-scrollbar v-if="platformListResult.total > 0" style="border: 1px solid #E7E7E7;margin-top: 10px;min-height: 500px;">
                                        <div style="display: flex;justify-content: center" v-for="(item,index) in platformListResult.list" :key="index">
                                            <div style="width: 95%;padding: 20px 0px;border-bottom: 1px dashed #E7E7E7;">
                                                <p class="platform-info-name" @click="gotoPlatformInfo(item)">{{ item.platformName }}</p>
                                                <div style="margin-top: 10px;">
                                                    <span class="platform-info-field">依托单位：{{ item.unitName }}</span>
                                                </div>
                                                <div class="platform-info-box">
                                                    <span class="platform-info-desc">简介：{{ item.briefIntroduction }}</span>
                                                </div>
                                            </div>

                                        </div>
                                    </el-scrollbar>
                                    <el-empty v-else description="暂无数据" style="min-height: 500px;" />
                                    <div style="display: flex;justify-content: center;margin-top: 25px;">
                                        <Pager
                                            @pageChange="pageChange"
                                            :layout="'total, prev, pager, next'"
                                            class="res-pager"
                                            :totalRecord="platformListResult.total"
                                            :totalPage="platformListResult.totalPage"
                                            :currentPage="currentPage"></Pager>

                                    </div>

                                </div>

                            </div>
                        </el-col>
                    </el-row>

                </div>

            </div>


        </div>
    </div>
</template>

<script setup >

import {ref, toRefs, reactive, getCurrentInstance, onMounted} from 'vue'
import { Search,RefreshRight } from '@element-plus/icons-vue'
import Bread from "@/components/common/Bread.vue";
import {useRoute} from "vue-router";
import Pager from "@/components/common/Pager.vue";


const {proxy} = getCurrentInstance();

const breads = ref([
    {text:'首页', path:'/zhaoqing/index'},
    {text:'实验室与平台基地', path:'/zhaoqing/zhaoqingPlatform'}
])

const inputtext = ref('')
const props2 = {
    multiple: true,
    checkStrictly: true,
}

const platformTypeActiveId = ref('')
const platformTypeList = ref([])


const getPlatformType = () => {
    proxy.$http.post('/gdsti2/web/a/webLab/platformCount').then(res => {
        if (res.data.state === 0) {
            platformTypeList.value = res.data.result;

        }
    }).catch(err => {
    });
}
const platformTypeLick = (item) => {
    platformTypeActiveId.value = item.typeCode;
    getPlatformList();
}

const loading = ref(false);
const platformListResult = ref({})


//页码
const currentPage = ref(1)
const pageChange = (index) => {
    currentPage.value = index;
    getPlatformList();
}


const getPlatformList = () => {
    loading.value = true;
    let param = {
        laboratoryTypeId: platformTypeActiveId.value,
        limit: 10,
        platformName: inputtext.value,
    }


    param.limit = 10;
    param.offset = (currentPage.value-1)*10;

    proxy.$http.post('/gdsti2/web/a/webLab/platformList',param).then(res => {
        if (res.data.state === 0) {
            platformListResult.value = res.data.result;

            loading.value = false;
        }
    }).catch(err => {
        loading.value = false;
    });
}

const gotoPlatformInfo = (item) => {
    let param = {
        id: item.id
    }
    proxy.$router.push({path: '/zhaoqing/zhaoqingPlatformInfo',query: param});
}



const route = useRoute();
onMounted(()=>{

    if(route.query && route.query.laboratoryTypeId){
        platformTypeActiveId.value = route.query.laboratoryTypeId;
    }
    getPlatformType();
    getPlatformList();
});


</script>

<style lang="less" scoped>


.text-center{
    text-align: center;
}



.platform-content-box{
    background: linear-gradient(180deg, #FFFFFF 0%, #F6F9FF 100%);
    background-size: 100% 600px;
    background-repeat: no-repeat;
    padding: 15px 20px;
    border-radius: 10px;
    margin-top: 15px;
}




.instrument-title{
    background-color: #007EEC;
    color: white;
    height: 40px;
    font-size: 18px;
    display:flex;
    align-items: flex-end;
    padding: 5px 15px;
}
.platform-type{
    margin-top: 10px;
    height: 51px;
    background: #E8F6F2;;
    text-align: center;
    line-height: 51px;
    border-radius: 5px;
}
.platform-type.active{
    background: #1EB38A;
    color: white;
}
.platform-type:hover{
    cursor: pointer;
}
.platform-info-name{
    font-family: 思源黑体;
    font-size: 18px;
    font-weight: 500;
    line-height: normal;
    letter-spacing: 0px;
    color: #1EB38A;
}
.platform-info-name:hover{
    cursor: pointer;
}
.platform-info-field{
    font-family: 思源黑体;
    font-size: 14px;
    font-weight: normal;
    line-height: normal;
    color: rgba(0, 0, 0, 0.85);
    margin-right: 27px;
}
.platform-count{
    font-family: 思源黑体;
    font-size: 20px;
    font-weight: normal;
    line-height: normal;
    letter-spacing: 0px;
}
.platform-info-desc{
    color: #A5A5A5;
    font-family: 思源黑体;
    font-size: 12px;
    font-weight: normal;
    line-height: 14px;
    letter-spacing: 0px;
}
.platform-info-box{
    height: 100px;
    overflow: hidden; /* 1. 隐藏超出内容 */
    text-overflow: ellipsis; /* 2. 超出部分显示省略号 */
    display: -webkit-box; /* 3. 将元素转为弹性伸缩盒子模型 */
    -webkit-line-clamp: 4; /* 4. 关键属性：限制显示的行数，比如2行就写2，3行写3 */
    -webkit-box-orient: vertical; /* 5. 关键属性：设置伸缩盒子的子元素排列方式为垂直 */
}
</style>

